import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store/index.js";

//Views
import NotFound from "./components/NotFound";

import Agent from "./pages/Agent";
import Home from "./pages/Home";
import Instructor from "./pages/Instructor";
import Addons from "./pages/Addons";
import Merch from "./pages/Merch";
import Pilot from "./pages/Pilot";
import Plain from "./pages/Plain";
import Manifest from "./pages/Manifest";
import Results from "./pages/Results";
import Dashboard from "./pages/Dashboard";
import Product from "./pages/Product";

import InstructorsReport from "./reports/InstructorsReport";
import Resource from "./pages/Resource";
import DailyReport from "./reports/DailyReport";
import ReportbyDateRange from "./reports/ReportbyDateRange";

import Rig from "./pages/Rig";
import PckgSales from "./reports/PckgSales";
import ComponentsLog from "./reports/ComponentsLog";
import Packer from "./pages/Packer";
import ResourcesLog from "./reports/ResourcesLog";
import Transactions from "./reports/Transactions";
import Jumps from "./pages/Jumps";
import User from "./pages/User";
import Role from "./pages/Role";
import Task from "./pages/Task";
import WagesReport from "./reports/WagesReport";
import WagesReports from "./reports/WagesReports";

const View = { template: "<router-view></router-view>" };

Vue.use(VueRouter);

let router = new VueRouter({
    mode: "history",
    routes: [
        {
            path: "/home",
            component: Home,
            name: "check-in",
            meta: { gate: "checkin-access" }
        },
        {
            path: "/transactions",
            component: Transactions,
            name: "transactions",
            meta: { gate: "sales-access" }
        },
        {
            path: "/jumps",
            component: Jumps,
            name: "jumps",
            meta: { gate: "checkin-access" }
        },

        {
            path: "/manifest",
            component: Manifest,
            name: "manifest",
            meta: { gate: "manifest-access" }
        },
        {
            path: "/results",
            component: Results,
            name: "jumps-search",
            meta: { gate: "checkin-access" }
        },
        {
            path: "/rigs",
            component: Rig,
            name: "rigs",
            meta: { gate: "gear-tracking-access" }
        },

        {
            path: "/settings",
            name: "settings",

            component: View,
            redirect: { name: "settings-dashboard" },
            children: [
                {
                    path: "dashboard",
                    component: Dashboard,
                    name: "settings-dashboard",
                    meta: { gate: "settings-access" }
                },
                {
                    path: "agents",
                    component: Agent,
                    name: "agents",
                    meta: { gate: "settings-access" }
                },
                {
                    path: "instructors",
                    component: Instructor,
                    name: "instructors",
                    meta: { gate: "settings-access" }
                },
                {
                    path: "addons",
                    component: Addons,
                    name: "addons",
                    meta: { gate: "settings-access" }
                },
                {
                    path: "merch",
                    component: Merch,
                    name: "merch",
                    meta: { gate: "settings-access" }
                },
                {
                    path: "pilots",
                    component: Pilot,
                    name: "pilots",
                    meta: { gate: "settings-access" }
                },
                {
                    path: "aircrafts",
                    component: Plain,
                    name: "aircrafts",
                    meta: { gate: "settings-access" }
                },
                {
                    path: "products",
                    component: Product,
                    name: "products",
                    meta: { gate: "settings-access" }
                },
                {
                    path: "resources",
                    component: Resource,
                    name: "resources",
                    meta: { gate: "settings-access" }
                },
                {
                    path: "packers",
                    component: Packer,
                    name: "packers",
                    meta: { gate: "settings-access" }
                },
                {
                    path: "users",
                    component: User,
                    name: "users",
                    meta: { gate: "users-mgmt" }
                },
                {
                    path: "roles",
                    component: Role,
                    name: "roles",
                    meta: { gate: "users-mgmt" }
                },

                {
                    path: "tasks",
                    component: Task,
                    name: "tasks",
                    meta: { gate: "users-mgmt" }
                }
            ]
        },

        {
            path: "/instructorsreport",
            component: InstructorsReport,
            name: "rangereport"
        },
        

        { path: "/dailyreport", component: DailyReport, name: "dailyreport" },
        {
            path: "/dailyreportrange",
            component: ReportbyDateRange,
            name: "dailyreportrange"
        },
        

        {
            path: "/pckgsales",
            component: PckgSales,
            name: "pckgsales",
            meta: { gate: "sales-access" }
        },
        {
            path: "/componentslog",
            component: ComponentsLog,
            name: "componentslog",
            meta: { gate: "gear-tracking-access" }
        },
        {
            path: "/resourceslog",
            component: ResourcesLog,
            name: "resourceslog",
            meta: { gate: "gear-tracking-access" }
        },
        {
            path: "/wagesreport/:range",
            component: WagesReport,
            name: "wagesreport",
            props: true,
            meta: { gate: "view-reports" }
        },
        {
            path: "/wages",
            component: WagesReports,
            name: "wages",
            meta: { gate: "view-reports" }
        },

        { path: "/notfound", component: NotFound, name: "notfound" }
    ]
});

router.beforeEach((to, from, next) => {
    

    if (
        to.path !== "/login" &&
        to.path !== "/register" &&
        to.path.startsWith("/password") === false
    ) {
        

        store.dispatch("getAbilities").then(() => {
            let gate = to.meta.gate;

            if (gate !== undefined && !store.getters.ability.includes(gate)) {
                next({ name: "dailyreport" });
            } else {
                next();
            }
        });
    }
});

export default router;
